import { render } from "./SwitchEditor.vue?vue&type=template&id=5d099b1a&ts=true"
import script from "./SwitchEditor.vue?vue&type=script&lang=ts"
export * from "./SwitchEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__